import React, {useState, Suspense} from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import UISunEditor from "components/wysiwygeditor/UISunEditor";
import PageLoading from "../../../../components/loading";
import TbComFile from "domain/main/com/file/TbComFile";
import UI from "components/UI";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import menuStore from "../../../../common/menu/store/MenuStore";


function ContentsContainer() {
    const history = useHistory();
    const location = useLocation();
    const [boardDetail, setBoardDetail] = useState<any>([]);
    const [files, setFiles] = useState<any[]>([]);
    const notiTpCd = 'N';
    const [notiNo, setNotiNo] = useState('');
    const [notiCont, setNotiCont] = useState<string>();
    const [flag, setFlag] = useState(false);

    // 파일
    const [fileValue, setFileValue] = useState(new TbComFile());
    const [loadFinish,setLoadFinish] = useState(false);

    const [notiFileValueTemp, setNotiFileValue] = useState(new TbComFile());
    const notiFileValue = React.useDeferredValue(notiFileValueTemp);

    //초기 데이터 설정
    let data = {};
    let param = {};

    async function getRead(notiNo) {

        const response:any = await CommonUtil.execute({
            url: 'usr_2301.jct',
            data: {NOTI_NO: notiNo,
                   NOTI_TP_CD: notiTpCd}
        }).then((response:any) => {
            setBoardDetail(response);
            setNotiCont(response.NOTI_CONT);

            const result = response;

            if(result.FILE_INFO.length > 0){
                let notiFileInfo = result.FILE_INFO;
                //파일등록 정보
                if (notiFileInfo) {
                    const tempTbComFile = new TbComFile();
                    notiFileInfo?.forEach((notiFileDetail, index) => {
                        const tbComFileMapngDetail = new TbComFileMapngDetail();
                        tbComFileMapngDetail.setDwldId(notiFileDetail.DWLD_ID);
                        tbComFileMapngDetail.setFileDetailId(notiFileDetail.FILE_DETAIL_ID);
                        tbComFileMapngDetail.setFilePolicy(notiFileDetail.FILE_POLICY);
                        tbComFileMapngDetail.setFileRpstr(notiFileDetail.FILE_RPSTR);
                        tbComFileMapngDetail.setStrePath(notiFileDetail.STRE_PATH);
                        tbComFileMapngDetail.setStreFileNm(notiFileDetail.STRE_FILE_NM);
                        tbComFileMapngDetail.setOrginlFileNm(notiFileDetail.ORGINL_FILE_NM);
                        tbComFileMapngDetail.setFileExtsn(notiFileDetail.FILE_EXTSN);
                        tbComFileMapngDetail.setFileSize(Number(notiFileDetail.FILE_SIZE));
                        tbComFileMapngDetail.setRegistDt(new Date(notiFileDetail.REGIST_DT));
                        tbComFileMapngDetail.setRegistPsnNm(notiFileDetail.REGIST_PSN_NM);

                        tempTbComFile.putTbComFileMapngDetailList(tbComFileMapngDetail);
                    })
                    setNotiFileValue(tempTbComFile);
                }
            }

            setLoadFinish(true);
        }).catch(err => {
            CommonUtil.showAxiosError(err);
            return;
        });

    }

    function pageMove(prevAndNext) {
        setNotiNo(prevAndNext);
    }

    React.useEffect(() => {
        menuStore.menuList?.forEach(menu => {
            // 메뉴를 통하지 않고 바로 들어온 경우에 대한 현재 메뉴 세팅
            if(menu.menuId === "SEL25956413CA29750")
                menuStore.setCurrentMenu(menu);
        })

        const receivedData = (location.state as any)?.data;
        const params = new URLSearchParams(location.search);
        const notiId = params.get("no");

        if(!flag) {
            if(receivedData != undefined && receivedData?.NOTI_NO != ''){
                console.log("received : " + receivedData?.NOTI_NO);
                getRead(receivedData?.NOTI_NO);
            } else if(notiId != ''){
                console.log("param : " + notiId);
                getRead(notiId);
            }
            // getRead(receivedData?.NOTI_NO);
            setFlag(true);
        } else {
            getRead(notiNo);
        }

    }, [notiNo]);//effect

    // if(!loadFinish)
    //     return (
    //         <PageLoading />
    //     )
    // else
	return (
		<PageContainer session={false}>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="#">고객지원</Link></li>
					<li><Link to="#">안내사항</Link></li>
				</ul>
				<main className="fww-main" data-layout="usr">
					<h1 className="tx tx-hd2">안내사항</h1>
					<div className="tb tb-view">
						<div className="tb-view-top">
							<div className="tb-view-title">
							    {boardDetail.NOTI_DIV_CD == '1' &&
							        <span className="badge badge-24 red">공지</span>
							    }
								<h3 className="title">{boardDetail.NOTI_TITLE}</h3>
							</div>
							<ul className="tb-view-info">
								<li>작성자<span className="val">{boardDetail.PERSON_NM}</span></li>
                                <li>등록일<span className="val">{DateUtil.toDateFormat(boardDetail.REG_DATE, "YYYY-MM-DD")}</span></li>
                                <li>조회수<span className="val">{boardDetail.RET_CNT}</span></li>
							</ul>
						</div>
					</div>
                    <div className="tb-view-file">
                        <UI.FileDownloadSimpleMode value={notiFileValue} viewMode={"simple2"} />
                    </div>
					<div className="tb-view-cont">
					    <Suspense fallback={<PageLoading/>}>
						    <UISunEditor value={notiCont} displayOnly={true} readOnly={true} />
						</Suspense>
					</div>
					<div className="tb-view-move">
						<ul>
                            {boardDetail.PREV_NOTI_NO != null ? (
                                    <li><label className="prev">이전글</label>
                                        <a href="#" onClick={(e) => {e.preventDefault(); pageMove(boardDetail.PREV_NOTI_NO);}} className="tx tx-bd2 tx-link">{boardDetail.PREV_NOTI_TITLE}</a>
                                    </li>
                                ) : (
                                    <li className="disabled"><label className="prev">이전글</label> 이전글이 없습니다.</li>
                            )}
                            {boardDetail.NEXT_NOTI_NO != null ? (
                                    <li><label className="next">다음글</label>
                                        <a href="#" onClick={(e) => {e.preventDefault(); pageMove(boardDetail.NEXT_NOTI_NO);}} className="tx tx-bd2 tx-link">{boardDetail.NEXT_NOTI_TITLE}</a>
                                    </li>
                                ) : (
                                    <li className="disabled"><label className="next">다음글</label> 다음글이 없습니다.</li>
                            )}
                        </ul>
					</div>
					<div className="hz-root hz-center">
						<Button color='gray-o' size="big" href="/main/usr_2300/usr_2300">목록</Button>
					</div>
				</main>
			</div>			
		</PageContainer>
	);
}
export default ContentsContainer;